import searchIcon from '@SvgIcon/search.svg'
import newWindowIcon from '@SvgIcon/android-open.svg'

import debounce from 'lodash/debounce'
import $ from 'jquery'
import Vue from 'vue'
import Mousetrap from 'mousetrap'
import svgIconHtml from '../../../shared/svgIconHtml'

const SearchComponent = Vue.extend({
  // language=HTML (for PhpStorm)
  template: `
    <div>
      <form class="search-form" :action="searchUrl" method="get" @submit.prevent="doSearch">
        <div class="search-form__query">
          <input v-model="keywords" type="text" name="query" placeholder="SEARCH" aria-label="Search query" />
        </div>
        <div class="search-form__in" v-if="searchables.length > 1">
          <fieldset>
            <legend class="show-for-sr">Search in</legend>
            <div v-for="searchable in searchables" :key="searchable.key" class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" name="indexes[]" :value="searchable.key"
                  v-model="indexes">
                {{ searchable.caption }}
              </label>
            </div>
          </fieldset>
        </div>
        <button type="submit" class="button show-for-sr" aria-label="Perform search">
          ${svgIconHtml(searchIcon)}
        </button>
      </form>

      <ui-progress-circular v-if="searching" :size="64" :indeterminate="true" />

      <div v-if="!searching && hasSearched" class="search-results">
        <div v-if="!results.length" class="no-results">
          <p>
            Your search - <b>{{ keywords }}</b> - did not match any documents.
          </p>

          <p>
            Suggestions:
          </p>

          <ul>
            <li>Make sure all words are spelled correctly.</li>
            <li>Try different keywords.</li>
            <li>Try more general keywords.</li>
          </ul>
        </div>
        <div v-else>
          <div v-for="result in results" class="search-result">
            <div v-if="result.photo" class="search-result__photo">
              <img :src="result.photo" alt="">
            </div>
            <div class="search-result__info">
              <div class="search-result__title">
                <a v-if="result.url" :href="result.url" :target="result.newWindow ? '_blank' : 'self'">
                  {{ result.title }}
                  <template v-if="result.newWindow">${svgIconHtml(newWindowIcon)}</template>
                </a>
                <span v-else>{{ result.title }}</span>
              </div>

              <div v-if="result.crumbs.length" class="search-result__crumbs">
                <ul class="breadcrumbs">
                  <li v-for="crumb in result.crumbs">
                    {{ crumb }}
                  </li>
                </ul>
              </div>

              <div v-if="result.description" class="search-result__description">
                {{ result.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  props: {
    searchUrl: {
      type: String,
      required: true,
    },
    searchables: {
      type: Array,
    },
  },
  data() {
    return {
      keywords: '',
      indexes: this.searchables.filter(searchable => searchable.default).map(searchable => searchable.key),
      searching: false,
      hasSearched: false,
      results: [],
    }
  },
  watch: {
    keywords() {
      this.doDebouncedSearch()
    },
    indexes() {
      this.doDebouncedSearch()
    },
  },
  methods: {
    doSearch() {
      if (this.searchXhr) {
        this.searchXhr.abort()
      }

      if (this.keywords === '') {
        this.setResults([])
        return
      }

      this.searching = true
      this.searchXhr = $.ajax({
        type: 'GET',
        url: this.searchUrl,
        data: {
          query: this.keywords,
          indexes: this.indexes,
        },
      })
        .always(() => {
          this.searching = false
        })
        .done((results) => {
          this.setResults(results)
        })
        .fail((xhr) => {
          if (xhr.responseJSON && 'redirect' in xhr.responseJSON) {
            document.location.href = xhr.responseJSON.redirect
          }
        })
    },

    doDebouncedSearch: debounce(function search() {
      this.doSearch()
    }, 200),

    setResults(results) {
      if (this.keywords === '') {
        this.hasSearched = false
        this.results = []
        return
      }

      this.hasSearched = true
      this.results = results
    },
  },
  created() {
    this.searchXhr = null
  },
})

if (document.getElementById('modal-search-app')) {
  new Vue({
    el: '#modal-search-app',
    render(h) {
      return h(SearchComponent, {
        props: {
          searchUrl: this.$el.attributes['data-search-url'].value,
          searchables: JSON.parse(this.$el.attributes['data-searchables'].value),
        },
      })
    },
  })
}

const $searchModal = $('#modal-search')
if ($searchModal.length) {
  $searchModal
    .on('open.zf.reveal.search', () => {
      setTimeout(() => {
        $searchModal.find('input:first').focus()
      }, 50)
    })

  Mousetrap.bind('ctrl+/', () => {
    $searchModal.foundation('open')
  })
}
